type FontPreload = {
  href: string;
  type: string;
};

const JAPANESE_FONTS: FontPreload[] = [
  {
    href: "/fonts/tazugane-gothic/ttf/TazuganeGothicStdN-Medium.ttf",
    type: "font/ttf",
  },
  {
    href: "/fonts/tazugane-gothic/ttf/TazuganeGothicStdN-Heavy.ttf",
    type: "font/ttf",
  },
];

const KOREAN_FONTS: FontPreload[] = [
  {
    href: "/fonts/sandoll-gothic-neo-1/woff2/SDnfxGothicNeoaUniTTF-dRg.woff2",
    type: "font/woff2",
  },
  {
    href: "/fonts/sandoll-gothic-neo-1/woff2/SDnfxGothicNeoaUniTTF-gBd.woff2",
    type: "font/woff2",
  },
];

function injectPreloads(fonts: FontPreload[]): void {
  const existingHrefs = new Set(
    Array.from(document.head.querySelectorAll('link[rel="preload"][as="font"]'))
      .map((link) => link.getAttribute("href"))
      .filter((href): href is string => Boolean(href))
  );
  const fragment = document.createDocumentFragment();
  for (const font of fonts) {
    if (existingHrefs.has(font.href)) {
      continue;
    }
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "font";
    link.href = font.href;
    link.type = font.type;
    link.crossOrigin = "anonymous";
    fragment.appendChild(link);
  }
  document.head.appendChild(fragment);
}

function getLocalePathSegment(): string | undefined {
  return window.location.pathname.split("/")[1]?.toLowerCase();
}

export function injectCjkFontPreloads(localeHint?: string): void {
  const locale = (localeHint ?? getLocalePathSegment())?.toLowerCase();

  if (locale === "ja-jp") {
    injectPreloads(JAPANESE_FONTS);
  } else if (locale === "ko-kr") {
    injectPreloads(KOREAN_FONTS);
  }
  // All other locales: no CJK fonts needed
}
